(function () {
  'use strict';

  function userLink(User) {
    var link = function ($scope, element, attrs) {
      $scope.image = attrs.image === 'true' || '';

      // user can be undefined: callers bind values like project.client, which resolve to undefined
      // when the project is unset on state exit or the payload lacks the user (KB-8727)
      $scope.showProfile = function (task, user) {
        if (!user) {
          return
        }

        User.showProfile(task, user.id, user.role);
      };

      $scope.canShowProfile = () => {
        return !!$scope.user && $scope.user.role !== 'superuser'
      }

      $scope.avatarImage = () => {
        if (!$scope.user) {
          return
        }

        const avatar = $scope.user.avatar ? $scope.user.avatar : $scope.user.avatars
        if (avatar) {
          return avatar.mediumUrl
        }
      }
    };

    return {
      restrict: 'E',
      scope: {
        user: '=',
        task: '=',
        showHire: '='
      },
      replace: true,
      templateUrl: require('../../views/directives/user_link.html'),
      link: link
    };
  }

  app.directive('userLink', ['User', userLink]);
})();
